import { pct } from "@/lib/api";

const LABELS = { overall: "Career", track: "Track", distance: "Distance", track_distance: "Track & dist", first_up: "First up", second_up: "Second up" };

const Cell = ({ label, s }) => (
  <div className="rounded-lg bg-[#0B101D] border border-white/5 px-2.5 py-1.5">
    <p className="text-[10px] uppercase tracking-widest text-slate-500">{label}</p>
    <p className="font-mono text-xs text-slate-200">{s.starts}: {s.wins}-{s.places - s.wins >= 0 ? s.places - s.wins : 0}
      <span className={`ml-1.5 ${pct(s) >= 20 ? "text-emerald-400" : "text-slate-400"}`}>{pct(s) ?? 0}%</span></p>
  </div>
);

export const FormStats = ({ stats, testid }) => {
  if (!stats) return null;
  const conds = stats.conditions || {};
  return (
    <div data-testid={testid} className="space-y-2">
      <p className="text-[10px] uppercase tracking-widest text-slate-500">Record (starts: wins-places, win %)</p>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        {Object.entries(LABELS).map(([k, l]) => stats[k] && <Cell key={k} label={l} s={stats[k]} />)}
        {Object.entries(conds).map(([k, s]) => <Cell key={k} label={k} s={s} />)}
      </div>
    </div>
  );
};
